import React from 'react';
import '../TeleCalling.css';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Stack,
    Typography,
    Button,
} from '@mui/material';
import { Call, WifiCalling3 as WifiCallingIcon } from '@mui/icons-material';
import { handleValidateCodevalue } from '../../../Utility/constant';


const ChooseCallDialog = ({
    chooseDialog,
    onClose,
    isConfigured,
    onChooseApp,
    internationalise,
}) => {
    return (
        <Dialog
            open={chooseDialog.open}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle className="tc-dialog-title-bold">
                {handleValidateCodevalue(internationalise, 'TC_CHOOSE_CALL_METHOD') || 'How would you like to call?'}
            </DialogTitle>

            <DialogContent>
                <Stack spacing={2} className="tc-pt-1">
                    <Typography variant="body2" color="text.secondary">
                        {handleValidateCodevalue(internationalise, 'TC_NOT_CONFIGURED') || 'Telecalling integration is not configured.'}
                    </Typography>

                    {/* Browser app option — only shown when configured */}
                    {isConfigured && (
                        <Button
                            variant="contained"
                            fullWidth
                            startIcon={<WifiCallingIcon />}
                            onClick={onChooseApp}
                            className="tc-btn-browser-app"
                        >
                            {handleValidateCodevalue(internationalise, 'TC_CALL_VIA_APP') || 'Call via Browser App'}
                        </Button>
                    )}

                    {/* Device / native dialer */}
                    <Button
                        variant="contained"
                        fullWidth
                        startIcon={<Call />}
                        href={`tel:${chooseDialog.phone}`}
                        className="tc-btn-device-call"
                    >
                        {isConfigured
                            ? (handleValidateCodevalue(internationalise, 'TC_CALL_VIA_DEVICE') || `Call ${chooseDialog.phone} via Device`)
                            : `Call ${chooseDialog.phone} via Device`}
                    </Button>

                    <Button
                        variant="outlined"
                        fullWidth
                        onClick={onClose}
                        className="tc-text-none"
                    >
                        {handleValidateCodevalue(internationalise, 'COMMON_CANCEL') || 'Cancel'}
                    </Button>
                </Stack>
            </DialogContent>
        </Dialog>
    );
};

export default ChooseCallDialog;
